import { render, staticRenderFns } from "./freelancer_apply_xhs_create.vue?vue&type=template&id=42711724&scoped=true&"
import script from "./freelancer_apply_xhs_create.vue?vue&type=script&lang=js&"
export * from "./freelancer_apply_xhs_create.vue?vue&type=script&lang=js&"
import style0 from "./freelancer_apply_xhs_create.vue?vue&type=style&index=0&id=42711724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42711724",
  null
  
)

export default component.exports